import { HttpError } from "@refinedev/core";
import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import toast from "react-hot-toast";

import CONFIG from "app-config/config.json";
import { canAccessByType } from "utills/helpers";
import { UserType } from "interfaces";
import i18n from "utills/i18n";

const AUTH_TOKEN = CONFIG.AUTH_TOKEN;

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (request: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("access-token");
    const lang = localStorage.getItem("lang");

    if (request.headers) {
      request.headers["accept-language"] = lang && lang !== "" ? lang : "vi";
      if (canAccessByType(UserType.ADMIN)) {
        request.headers["Authorization"] = `Bearer ${AUTH_TOKEN}`;
      }
      if (token) {
        request.headers["access-token"] = token;
      }
    } else {
      request.headers = new AxiosHeaders({
        ...(canAccessByType(UserType.ADMIN) && {
          Authorization: `Bearer ${AUTH_TOKEN}`,
        }),
        "access-token": token,
        "accept-language": lang && lang !== "" ? lang : "vi",
      });
    }

    return request;
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const customError: HttpError = {
      ...error,
      // errors: error.response?.data?.errors,
      message: error.response?.data?.message,
      statusCode: error.response?.code_status,
    };
    const errorMessage =
      i18n.t((customError.message ?? "").replace(":", "")) ||
      "Error has occured!";
    toast.error(errorMessage, {
      id: errorMessage ?? "",
      position: "top-right",
      duration: 6000,
    });
    return Promise.reject(customError);
  },
);

export { axiosInstance };
